import React from "react";
import Chart from "./Chart";
import { getPermissionObject } from "../../utils/useful";
import moment from "moment";

class ContractsChartWidget extends React.Component {
    render() {
        const widget = this.props.widget || this.props.data
        const variables = this.props.variables || {}
        const chartType = widget?.type || 'doughnut'
        
        // Prepare data for Chart component
        // Chart expects: { filter, groupBy, frame }
        let appletValue = variables.applet || widget.postBody?.applet
        
        // Remove {{applet}} placeholder if present and no applet provided
        if (appletValue && typeof appletValue === 'string' && appletValue.includes('{{applet}}')) {
            appletValue = variables.applet || null
        }

        // Build filter - include postBody filters but only add applet if provided
        const filter = { ...(widget.postBody || {}) }
        
        // Only add applet to filter if it's provided (for branch-specific widgets)
        // If no applet, it will be global (all applets)
        if (appletValue) {
            filter.applet = appletValue
        } else {
            // Remove applet from filter if it was in postBody but we want global
            delete filter.applet
        }

        // Add time filter if specified
        if (widget.timeFilter) {
            const now = moment()
            let startDate
            
            switch (widget.timeFilter) {
                case 'week':
                    startDate = now.clone().subtract(1, 'week').startOf('day').valueOf()
                    break
                case 'month':
                    startDate = now.clone().subtract(1, 'month').startOf('day').valueOf()
                    break
                case '3months':
                    startDate = now.clone().subtract(3, 'months').startOf('day').valueOf()
                    break
                case '6months':
                    startDate = now.clone().subtract(6, 'months').startOf('day').valueOf()
                    break
                default:
                    startDate = null
            }
            
            if (startDate) {
                filter['uDate'] = { $gte: startDate }
            }
        }

        // TODO: Backend permissions - Currently commented out for backend permission implementation
        // Add user filter if user has "self" permission
        // const permissionRoot = variables?.permissionRoot
        // if (permissionRoot && this.props.user?.info) {
        //     const userPermissions = this.props.user.info.permissions || []
        //     let hasSelfPermission = false
        //     
        //     // Check if user has "self" permission
        //     for (let i = 0; i < userPermissions.length; i++) {
        //         const userPermission = userPermissions[i].permissions
        //         const permResult = getPermissionObject(userPermission, permissionRoot + '.self')
        //         if (permResult?.allowed) {
        //             hasSelfPermission = true
        //             break
        //         }
        //     }
        //     
        //     // If user has "self" permission, filter by their user ID
        //     if (hasSelfPermission && this.props.user.info._id) {
        //         filter.user = this.props.user.info._id
        //     }
        // }
        
        // For now, if user has "self" permission (checked in AdminWidgetsPage), send user as filter
        // This will be handled by backend permissions later
        if (this.props.user?.info?._id) {
            // Backend will handle permission-based filtering
            // filter.user = this.props.user.info._id // Uncomment when backend is ready
        }

        const chartData = {
            filter: filter,
            groupBy: 'values.lastFollowUpResult',
            frame: widget.page || 'forms', // Use 'forms' as default since all data are records with page of 'forms'
            // permissionRoot: permissionRoot
        }

        return (
            <div className="w-100" style={{ minHeight: 200 }} ref={el => this.chartContainer = el}>
                <Chart 
                    chartType={chartType}
                    data={chartData}
                    applet={appletValue || undefined} // Pass undefined if no applet (global)
                    frame={chartData.frame}
                    user={this.props.user}
                />
            </div>
        )
    }
}

export default ContractsChartWidget

